import ErrorsList from "./list";

export const ErrorsPage = () => {

    return(
        <ErrorsList title='שגיאות לקוח'/>
    )

};

export default ErrorsPage;
